(() => {
  if (customElements.get('apple-product-viewer')) return;

  class AppleProductViewer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.component = this.querySelector('[data-apv-component]');
      this.items = Array.from(this.querySelectorAll('[data-apv-item]'));
      this.openButtons = Array.from(this.querySelectorAll('[data-apv-open]'));
      this.panels = Array.from(this.querySelectorAll('[data-apv-panel]'));
      this.colorButtons = Array.from(this.querySelectorAll('[data-apv-color]'));
      this.colorName = this.querySelector('[data-apv-color-name]');
      this.selectedColorDot = this.querySelector('[data-apv-selected-color-dot]');
      this.closeButton = this.querySelector('[data-apv-close]');
      this.prevButton = this.querySelector('[data-apv-prev]');
      this.nextButton = this.querySelector('[data-apv-next]');
      this.activeIndex = 0;
      this.activeColorPanel = this.colorButtons[0]?.dataset.apvPanelTarget || 'colors-orange';

      this.openButtons.forEach((button) => {
        button.addEventListener('click', () => this.openItem(button.dataset.apvOpen));
      });

      this.colorButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          this.selectColor(button);
        });
      });

      this.closeButton?.addEventListener('click', () => this.close());
      this.prevButton?.addEventListener('click', () => this.step(-1));
      this.nextButton?.addEventListener('click', () => this.step(1));

      this.component?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.step(-1);
        }

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.step(1);
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
        }
      });

      this.close();
    }

    openItem(key) {
      const item = this.items.find((candidate) => candidate.dataset.apvItem === key);
      if (!item || !this.component) return;

      this.component.classList.add('is-expanded');
      this.activeIndex = Number(item.dataset.apvIndex) || 0;

      this.items.forEach((candidate) => {
        const isOpen = candidate === item;
        const content = candidate.querySelector('.control-item-content');
        const button = candidate.querySelector('[data-apv-open]');

        candidate.classList.toggle('is-open', isOpen);
        candidate.classList.toggle('is-current', isOpen);
        content?.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        button?.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      this.showPanel(key === 'colors' ? this.activeColorPanel : key);
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    selectColor(button) {
      this.activeColorPanel = button.dataset.apvPanelTarget || 'colors-orange';

      this.colorButtons.forEach((candidate) => {
        const isActive = candidate === button;
        candidate.classList.toggle('is-active', isActive);
        candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      if (this.colorName && button.dataset.apvName) {
        this.colorName.textContent = button.dataset.apvName;
      }

      if (this.selectedColorDot && button.dataset.apvColor) {
        this.selectedColorDot.className = `apv__color-dot apv__color-dot--${button.dataset.apvColor}`;
      }

      this.openItem('colors');
    }

    showPanel(key) {
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.apvPanel === key;
        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    close() {
      this.component?.classList.remove('is-expanded');
      this.activeIndex = 0;

      this.items.forEach((item) => {
        const isColorItem = item.dataset.apvItem === 'colors';
        const content = item.querySelector('.control-item-content');
        const button = item.querySelector('[data-apv-open]');

        item.classList.remove('is-open');
        item.classList.toggle('is-current', isColorItem);
        content?.setAttribute('aria-hidden', 'true');
        button?.setAttribute('aria-expanded', 'false');
      });

      this.showPanel('initial');
    }

    step(direction) {
      if (!this.items.length) return;

      const nextIndex = (this.activeIndex + direction + this.items.length) % this.items.length;
      const nextItem = this.items.find((item) => Number(item.dataset.apvIndex) === nextIndex) || this.items[nextIndex];
      const key = nextItem?.dataset.apvItem;

      if (key) {
        this.openItem(key);
      }
    }
  }

  customElements.define('apple-product-viewer', AppleProductViewer);
})();
